import React from 'react'
import NotificationList from 'components/layout/Header/components/NotificationsContainer/components/NotificationList'
import {
  useMarkAsRead,
  useNotificationsPolling,
} from 'components/layout/Header/components/NotificationsContainer/hooks'
import { Spinner } from 'transfix-ui/components/Spinner'
import { Box, BoxProps as MuiBoxProps, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

const useStyles = makeStyles(theme => ({
  root: {
    width: 'auto',

    [theme.breakpoints.up('lg')]: {
      width: 450,
    },
  },
  emptyState: {
    padding: theme.spacing(2),
    backgroundColor: brandColors.coolGray1,
    textAlign: 'center',
    border: `1px solid ${brandColors.coolGray4}`,
    borderRadius: '5px',
  },
  loading: {
    padding: theme.spacing(2),
    backgroundColor: brandColors.coolGray1,
    textAlign: 'center',
    border: `1px solid ${brandColors.coolGray4}`,
    borderRadius: '5px',
  },
}))

interface INotificationsMenuProps extends MuiBoxProps {}

const NotificationsMenu = (props: INotificationsMenuProps) => {
  const classes = useStyles()
  const { markAsRead } = useMarkAsRead()
  const { loading, notifications = [], unreadCount } = useNotificationsPolling()
  return (
    <Box data-test='NotificationsMenu' className={classes.root} {...props}>
      {!loading && notifications.length > 0 && unreadCount > 0 && (
        <NotificationList notifications={notifications} onMarkAsRead={markAsRead} />
      )}
      {loading && (
        <div className={classes.loading}>
          <Spinner position='relative' />
        </div>
      )}
      {!loading && notifications.length === 0 && unreadCount === 0 && (
        <Box className={classes.emptyState}>
          <Typography color='textSecondary' variant='body2' align='center' component='div'>
            No notifications
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default NotificationsMenu
